import React, { Component } from 'react';
import { Title } from 'web-ui-components/lib/atoms/text';
import { Content } from '../../../infrastructure/content';
import AccountTurnoverDetails from './AccountTurnoverDetails';
import PaymentType from './PaymentType';
import AccountPaymentMade from './AccountPaymentMade';
import PaymentCredited from './PaymentCredited';
import PaymentTransfer from './PaymentTransfer';
import CountrySelect from './CountrySelect';
import { PAYMENT_TRANSFER } from '../accoundDetailsUtil';
import { SEND_PAYMENTS, RECEIVE_PAYMENTS } from '../../../utils/constants';

class AccountDetailsGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendPayments: [],
      receivePayments: [],
      isPristine: true
    };
    this.getSelectedCountries = this.getSelectedCountries.bind(this);
  }
  onCountryChange(data, isRemoved, values) {
    if (data.type === SEND_PAYMENTS) {
      this.setState({
        sendPayments: data.list,
        receivePayments: this.getPaymentsFromProps('receive_payments', this.state.receivePayments)
      });
      values.send_payments = values.send_payments
        ? values.send_payments.filter(payment =>
            data.list.find(vv => vv === Object.keys(payment)[0])
          )
        : [];
    } else if (data.type === RECEIVE_PAYMENTS) {
      this.setState({
        receivePayments: data.list,
        sendPayments: this.getPaymentsFromProps('send_payments', this.state.sendPayments)
      });
      values.receive_payments = values.receive_payments
        ? values.receive_payments.filter(payment =>
            data.list.find(vv => vv === Object.keys(payment)[0])
          )
        : [];
    }
    if (
      isRemoved &&
      this.props.getBusinessData &&
      Object.values(this.props.getBusinessData).join('')
    ) {
      this.props.onCountryRemove(values);
    }
  }
  getPaymentsFromProps(type, stateData) {
    return stateData && stateData.length > 0
      ? stateData
      : this.props.getBusinessData && this.props.getBusinessData[type]
      ? this.props.getBusinessData[type]
      : [];
  }
  getSelectedCountries(payment) {
    const payments = this.props.getBusinessData ? this.props.getBusinessData[payment] : [];
    return payments && payments.length > 0 ? payments.map(country => Object.keys(country)[0]) : [];
  }
  render() {
    const {
      values,
      pristine,
      reviewFlag,
      isPristine,
      onAccountDetailsChange,
      getBusinessData
    } = this.props;
    return (
      <Content>
        {({
          accountDetailsPageTitle = '',
          accountDetailsSendMoney,
          accountDetailsSupplyMoney,
          accountDetailsCheckBoxMakePaymentSub,
          accountDetailsCheckBoxReceivePaymentSub,
          internationalPaymentsErrors,
          percentFieldValidation,
          accountDetailCountrySelectionError
        }) => (
          <div>
            {reviewFlag ? '' : <Title size="h1">{accountDetailsPageTitle}</Title>}
            <AccountTurnoverDetails />
            <PaymentType values={values} pristine={pristine} />
            <AccountPaymentMade />
            <PaymentTransfer
              values={values}
              onChange={selectedId =>
                getBusinessData &&
                Object.values(getBusinessData).join('') &&
                onAccountDetailsChange({ target: { value: selectedId } })
              }
            />
            {values && values.accountDetailsPayment === PAYMENT_TRANSFER.MAKE_PAYMENTS && (
              <CountrySelect
                id="turnoverCustomers"
                name="send_payments"
                placeholder={accountDetailsCheckBoxMakePaymentSub}
                label={accountDetailsSendMoney}
                accordionLabel={accountDetailsCheckBoxMakePaymentSub}
                fieldValidation={internationalPaymentsErrors}
                percentFieldValidation={percentFieldValidation}
                formValues={values.send_payments}
                isPristine={isPristine}
                onAccountDetailsValueChange={(v, isRemoved) => {
                  this.onCountryChange({ list: v, type: 'send' }, isRemoved, values);
                }}
                getSelectedCountries={this.getSelectedCountries('send_payments')}
              />
            )}
            {values && values.accountDetailsPayment === PAYMENT_TRANSFER.RECEIVE_PAYMENTS && (
              <CountrySelect
                id="turnoverSuppliers"
                name="receive_payments"
                placeholder={accountDetailsCheckBoxReceivePaymentSub}
                label={accountDetailsSupplyMoney}
                accordionLabel={accountDetailsCheckBoxReceivePaymentSub}
                fieldValidation={accountDetailCountrySelectionError}
                formValues={values.receive_payments}
                percentFieldValidation={percentFieldValidation}
                isPristine={isPristine}
                onAccountDetailsValueChange={(v, isRemoved) => {
                  this.onCountryChange({ list: v, type: 'receive' }, isRemoved, values);
                }}
                getSelectedCountries={this.getSelectedCountries('receive_payments')}
              />
            )}

            {values && values.accountDetailsPayment === PAYMENT_TRANSFER.MAKE_AND_RECEIVE_PAYMENTS && (
              <div>
                <CountrySelect
                  id="turnoverCustomers"
                  name="send_payments"
                  placeholder={accountDetailsCheckBoxMakePaymentSub}
                  label={accountDetailsSendMoney}
                  accordionLabel={accountDetailsCheckBoxMakePaymentSub}
                  fieldValidation={internationalPaymentsErrors}
                  percentFieldValidation={percentFieldValidation}
                  formValues={values.send_payments}
                  isPristine={isPristine}
                  onAccountDetailsValueChange={(v, isRemoved) => {
                    this.onCountryChange({ list: v, type: 'send' }, isRemoved, values);
                  }}
                  getSelectedCountries={this.getSelectedCountries('send_payments')}
                />
                <CountrySelect
                  id="turnoverSuppliers"
                  name="receive_payments"
                  placeholder={accountDetailsCheckBoxReceivePaymentSub}
                  label={accountDetailsSupplyMoney}
                  accordionLabel={accountDetailsCheckBoxReceivePaymentSub}
                  fieldValidation={accountDetailCountrySelectionError}
                  formValues={values.receive_payments}
                  percentFieldValidation={percentFieldValidation}
                  isPristine={isPristine}
                  onAccountDetailsValueChange={(v, isRemoved) => {
                    this.onCountryChange({ list: v, type: 'receive' }, isRemoved, values);
                  }}
                  getSelectedCountries={this.getSelectedCountries('receive_payments')}
                />
              </div>
            )}
            <PaymentCredited values={values} />
          </div>
        )}
      </Content>
    );
  }
}

export default AccountDetailsGroup;
